export default __webpack_public_path__ + "static/media/mysweetchubs.ecb52dd6.png";